import { LOG_INFO_URL } from "../paths";
import {Axios} from "./Axios";

export const LogService = (logData: any): any => Axios.post(LOG_INFO_URL, logData);